"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PASSWORD_POLICY_ENFORCED = exports.PASSWORD_DOES_NOT_MEET_REQUIREMENTS = exports.WEAK_PASSWORD = exports.INVALID_ACTION_CODE = exports.EXPIRED_ACTION_CODE = exports.NETWORK_REQUEST_FAILED = exports.INVALID_VERIFICATION_CODE = exports.OPERATION_NOT_ALLOWED = exports.EMAIL_ALREADY_IN_USE = exports.MISSING_EMAIL = exports.INVALID_EMAIL = exports.USER_DISABLED = exports.TOO_MANY_REQUESTS = exports.INVALID_LOGIN_CREDENTIALS = exports.INVALID_CREDENTIAL = exports.USER_NOT_FOUND = exports.INCORRECT_PASSWORD = void 0;
var INCORRECT_PASSWORD = "auth/wrong-password";
exports.INCORRECT_PASSWORD = INCORRECT_PASSWORD;
var USER_NOT_FOUND = "auth/user-not-found";
exports.USER_NOT_FOUND = USER_NOT_FOUND;
var INVALID_CREDENTIAL = "auth/invalid-credential";
exports.INVALID_CREDENTIAL = INVALID_CREDENTIAL;
var INVALID_LOGIN_CREDENTIALS = "auth/invalid-login-credentials";
exports.INVALID_LOGIN_CREDENTIALS = INVALID_LOGIN_CREDENTIALS;
var TOO_MANY_REQUESTS = "auth/too-many-requests";
exports.TOO_MANY_REQUESTS = TOO_MANY_REQUESTS;
var USER_DISABLED = "auth/user-disabled";
exports.USER_DISABLED = USER_DISABLED;
var INVALID_EMAIL = "auth/invalid-email";
exports.INVALID_EMAIL = INVALID_EMAIL;
var MISSING_EMAIL = "auth/missing-email";
exports.MISSING_EMAIL = MISSING_EMAIL;
var EMAIL_ALREADY_IN_USE = "auth/email-already-in-use";
exports.EMAIL_ALREADY_IN_USE = EMAIL_ALREADY_IN_USE;
var OPERATION_NOT_ALLOWED = "auth/operation-not-allowed";
exports.OPERATION_NOT_ALLOWED = OPERATION_NOT_ALLOWED;
var INVALID_VERIFICATION_CODE = "auth/invalid-verification-code";
exports.INVALID_VERIFICATION_CODE = INVALID_VERIFICATION_CODE;
var NETWORK_REQUEST_FAILED = "auth/network-request-failed";
exports.NETWORK_REQUEST_FAILED = NETWORK_REQUEST_FAILED;
var EXPIRED_ACTION_CODE = "auth/expired-action-code";
exports.EXPIRED_ACTION_CODE = EXPIRED_ACTION_CODE;
var INVALID_ACTION_CODE = "auth/invalid-action-code";
exports.INVALID_ACTION_CODE = INVALID_ACTION_CODE;
var WEAK_PASSWORD = "auth/weak-password";
exports.WEAK_PASSWORD = WEAK_PASSWORD;
var PASSWORD_DOES_NOT_MEET_REQUIREMENTS = "auth/password-does-not-meet-requirements";
exports.PASSWORD_DOES_NOT_MEET_REQUIREMENTS = PASSWORD_DOES_NOT_MEET_REQUIREMENTS;
var PASSWORD_POLICY_ENFORCED = "ENFORCE";
exports.PASSWORD_POLICY_ENFORCED = PASSWORD_POLICY_ENFORCED;
